import { Modal, Button, Form, Input, Select, notification, Checkbox } from "antd";

export default function AuthModal({
  authMode,
  setAuthMode,
  login,
  signup,
  handleSendOtp,
  handleVerifyOtp,
  otpSent,
  otpResendTimer,
  otpTimerCount,
  setOtp,
  buttonLoading,
  typeOfBusinesses,
  showCustomBusinessType,
  setShowCustomBusinessType,
  customBusinessType,
  setCustomBusinessType,
  form2,
  otpVerified, // Add this prop
  otp, // Add this prop,
  showAuthModal, // Add this prop
  setShowAuthModal, // Add this prop
  setOtpSent, // Add this prop
}) {

  return (
    <Modal
      visible={showAuthModal}
      onCancel={() => {
        setShowAuthModal(false);
        setAuthMode("login");
        setOtpSent(false);
        setShowCustomBusinessType(false);
      }}
      footer={null}
      title={
        authMode === "login"
          ? "Login"
          : authMode === "signup"
          ? "Sign Up"
          : "Forgot Password"
      }
    >
    <div>
      {authMode === "login" ? (
        <Form onFinish={login} layout="vertical">
          <Form.Item
            label="Email or Mobile number"
            name="emailOrMobile"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={buttonLoading}>
            Login
          </Button>
          <Button type="link" onClick={() => setAuthMode("signup")}>
            Create account
          </Button>
          <Button type="link" onClick={() => setAuthMode("forgotPassword")}>
            Forgot Password?
          </Button>
        </Form>
      ) : authMode === "signup" ? (
        <Form onFinish={signup} layout="vertical">
          <Form.Item
            label="Business Name"
            name="businessName"
            rules={[{ required: true }]}
          >
            <Input placeholder="like XYZ clinic" />
          </Form.Item>
          <Form.Item
            label="Mobile Number"
            name="mobileNumber"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Select Business Type"
            name="businessType"
            rules={[{ required: true }]}
          >
            <Select
              onChange={(value) => {
                setShowCustomBusinessType(value === "other");
              }}
            >
              {typeOfBusinesses.map((business) => (
                <Select.Option value={business.value}>
                  {business.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {showCustomBusinessType && (
            <Form.Item
              label="Enter Business Type"
              name="customBusinessType"
              rules={[{ required: true }]}
            >
              <Input
                value={customBusinessType}
                onChange={(e) => setCustomBusinessType(e.target.value)}
              />
            </Form.Item>
          )}
          <Form.Item
            name="confirmMobileValid"
            valuePropName="checked"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please confirm that your mobile number is valid')),
              },
            ]}
          >
            <Checkbox>I confirm that mobile number is valid</Checkbox>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={buttonLoading}>
            Sign Up
          </Button>
          <Button type="link" onClick={() => setAuthMode("login")}>
            Already have an account
          </Button>
        </Form>
      ) : (
        <Form layout="vertical" form={form2}>
          <Form.Item
            label="Mobile Number"
            name="mobileNumber"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Button
            type="primary"
            onClick={() =>
              handleSendOtp(
                form2.getFieldInstance("mobileNumber")?.input?.value
              )
            }
            disabled={otpSent}
            loading={buttonLoading}
          >
            {otpSent ? "OTP Sent" : "Send OTP"}
          </Button>
          {otpSent && otpResendTimer && (
            <div style={{ marginTop: "10px" }}>
              <span>Resend OTP in {otpTimerCount}s</span>
            </div>
          )}
          {!otpResendTimer && otpSent && (
            <Button
              type="link"
              onClick={() =>
                handleSendOtp(
                  form2.getFieldInstance("mobileNumber")?.input?.value,
                  true
                )
              }
            >
              Resend OTP
            </Button>
          )}
          {otpSent && !otpVerified && (
            <div>
              <Form.Item
                label="Enter OTP"
                name="otp"
                rules={[{ required: true }]}
              >
                <Input value={otp} onChange={(e) => setOtp(e.target.value)} />
              </Form.Item>
              <Button type="primary" onClick={handleVerifyOtp} loading={buttonLoading}>
                Verify OTP
              </Button>
            </div>
          )}
          <Button type="link" onClick={() => setAuthMode("login")}>
            Back to Login
          </Button>
        </Form>
      )}
    </div>
    </Modal>
  );
}